import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode';
import { useTheme } from '@mui/material';

import { QR_ERROR_CORRECTION_LEVEL } from 'constants/components';

export const QrCode = ({ size = 160, value, level = QR_ERROR_CORRECTION_LEVEL.HIGH }) => {
  const canvasRef = useRef(null);
  const { palette } = useTheme();

  useEffect(() => {
    if (canvasRef.current && value) {
      QRCode.toCanvas(canvasRef.current, value, {
        errorCorrectionLevel: level,
        margin: 0,
        width: size,
        height: size,
        color: {
          dark: palette.text.primary,
        },
      });
    }
  }, [level, palette.text.primary, size, value]);

  return <canvas ref={canvasRef} />;
};

QrCode.propTypes = {
  size: PropTypes.number,
  value: PropTypes.string.isRequired,
  level: PropTypes.oneOf(Object.values(QR_ERROR_CORRECTION_LEVEL)),
};
